module.exports = "<table class=\"middleContainer2\">\r\n    <tr>\r\n        <td>\r\n            <div class=\"loginMiddle\">\r\n                <wechat-bind></wechat-bind>\r\n            </div>\r\n        </td>\r\n    </tr>\r\n</table>";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/wechatBind/WechatBindIndex.html
// module id = 181
// module chunks = 0